import React, { ReactNode } from 'react'
import { cookies, CookieType } from '../state/cookies'

interface ErrorBoundaryProps {
  children: ReactNode
  errorView: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state = { hasError: false }

  static getDerivedStateFromError(error: any) {
    console.log(error.source)
    if (
      error.source != null &&
      error.source.errors != null &&
      (error.source.errors[0]?.extensions?.code === 'FORBIDDEN' ||
        error.source.errors[0]?.extensions?.code === 'UNAUTHENTICATED')
    ) {
      cookies.remove(CookieType.AUTH)
      cookies.remove(CookieType.VIEWING_USER)
      window.location = '/' as unknown as Location
    }
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      return this.props.errorView
    }
    return this.props.children
  }
}

export default ErrorBoundary
